import styles from "./launch.module.scss"
import { ReactComponent as Launch } from "../../assets/launchrocket.svg";
import { ReactComponent as LaunchLoad } from "../../assets/launchload.svg";
import { ReactComponent as Logo } from "../../assets/autoloads-logo-black.svg";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAtom } from "jotai";
import { userData } from "../../state";


const Main = () => {
  const navigate = useNavigate();
  const [user] = useAtom(userData);  // Get the user data from state

  useEffect(() => {
      const timer = setTimeout(() => {
        if (user?.user?.profile_updated) {
          navigate('/dashboard', { replace: true }); // Redirect to dashboard if profile is complete
        } else {
          navigate('/complete-profile', { replace: true }); // Redirect to profile completion if not
        }
      }, 3000); // Adjust the delay time as needed

      return () => clearTimeout(timer);
  }, [navigate, user]);



    return(
        <section className={styles.sectionLayout}>

            <Launch className={styles.launchLogo}/>
          

            <h2>Launching Autoloads</h2>

            <p>Loading up your account</p>

            <LaunchLoad className={styles.launchload}/>

            <Logo className={styles.logo}/>
            <br />

        </section>
    )
}

export default Main;